import { mapGetters } from "vuex";
import * as types from "@/store/types";

const ShowCards = () => import("@/components/BankCard/ShowCards/index");
const AddCard = () => import("@/components/BankCard/AddCard/index");
export default {
  name: "user-registered-card",
  components: { ShowCards, AddCard },
  props: [],
  data() {
    return {
      addCardDialog: false,
      color: "lighterBackGround"
    };
  },
  computed: {
    ...mapGetters({
      getBankCard: types.operations.getters.GET_BANK_CARD
    })
  },
  mounted() {},
  methods: {
    handleDialog() {
      this.$emit("confirmOrder", false);
      this.addCardDialog = true;
    }
  }
};
